import React from "react";
import staff from "../assets/slider3.jpeg";
import { LuMoveLeft } from "react-icons/lu";
import { Link } from "react-router-dom";
import SectionHeadline from "./SectionHeadline";

export default function Ha() {
  return (
    <div className="md:px-0 px-4 flex justify-center items-center">
      <div className="md:shadow-md md:px-10 md:pb-4 flex flex-col md:gap-8 gap-4 justify-center md:w-10/12 w-full">
        <div
          data-aos="fade-down"
          data-aos-easing="linear"
          data-aos-duration="1500"
          className="flex flex-col"
        >
          <SectionHeadline
            title="   (PCL In General Medicine (HA)"
            backgroundImage={staff}
          />
        </div>

        <div
          data-aos="fade-up"
          data-aos-easing="linear"
          data-aos-duration="1500"
          className="flex flex-col gap-7"
        >
          <div className=" md:-mt-4">
            The PCL in General Medicine (HA) at Holy Vision Technical Campus
            (HVTC) offers a comprehensive curriculum emphasizing practical
            skills and theoretical knowledge in healthcare. With
            state-of-the-art facilities and experienced faculty, students gain
            hands-on training in patient care, clinical procedures, and medical
            ethics, preparing them to excel in the healthcare industry.
          </div>
          <p>
            {" "}
            <strong> Duration: </strong> 3 years
          </p>
          <p>
            <strong>Affiliation: </strong> Council for Technical Education and
            Vocational Training (CTEVT)
          </p>
          <div className="flex flex-col gap-4">
            <strong>Eligibility:</strong>
            <div className=" flex flex-col gap-4">
              <li>Completion of SEE or equivalent with a minimum GPA of 2.0</li>
              <li>TSLC (CMA) With minimum 68.33%</li>
            </div>
          </div>
          <strong>Course Structure:</strong>
          {courseStructure.map((year, index) => (
            <div key={index} className="flex flex-col gap-4">
              <strong>{year.title}:</strong>
              <div className=" flex flex-col gap-4">
                {year.courses.map((course, idx) => (
                  <li key={idx}>{course}</li>
                ))}
              </div>
            </div>
          ))}
          <div className="flex flex-col gap-4">
            <strong>Career Prospects:</strong>
            <div className=" flex flex-col gap-4">
              {careerProspects.map((prospect, idx) => (
                <li key={idx}>{prospect}</li>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <strong>Key Features:</strong>
            <div className=" flex flex-col gap-4">
              {keyFeatures.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <strong>Facilities:</strong>
            <div className=" flex flex-col gap-4">
              {facilities.map((facility, idx) => (
                <li key={idx}>{facility}</li>
              ))}
            </div>
          </div>
          <div>
            <strong>Fee Structure</strong>
            <p className=" mt-2">4 Lakh 4 Thousnad Only (NPR.404000/-)</p>
          </div>
          <div className="flex flex-col gap-4">
            <strong>
              Why Holy Vision Technical Campus for PCL In General Medicine (HA)?
            </strong>
            <div className=" flex flex-col gap-4">
              {whyChooseHVTC.map((reason, idx) => (
                <li key={idx}>{reason}</li>
              ))}
            </div>
          </div>
          <strong>
            For more information or to apply, please visit the Holy Vision
            Technical Campus (HVTC) website or contact the admissions office.
          </strong>
          <Link
            to="/"
            className="cursor-pointer mt-4 hover:text-gray-700 flex gap-1 items-center justify-center"
          >
            <LuMoveLeft size={25} className="text-gray-800" />
            <p className="text-[18px]">Back</p>
          </Link>
        </div>
      </div>
    </div>
  );
}

const courseStructure = [
  {
    title: "First Year",
    courses: [
      "English",
      "Nepali",
      "Social Studies (Nepali Parichaya)",
      "Mathematics , Statistics & Computer Application",
      "Physics ",
      "Chemistry ",
      "Zoology",
      "Botany",
      "Anatomy & Physiology",
    ],
  },
  {
    title: "Second Year",
    courses: [
      "Medicine-I ",
      "Surgery-I ",
      "Gynecology & Procedures/First Aid ",
      "Foundation of Health Education ",
      "Clinical Pharmacology Education ",
      "Primary Health Care/Family Health ",
      "Clinical Pharmacology and Pharmacy ",
      "Environmental Health ",
    ],
  },
  {
    title: "Third Year",
    courses: [
      "Medicine-II (Pediatrics) ",
      "Medicine-II(Psychiatry) ",
      "Medicine-II(Dermatology) ",
      "Surgery-II (ENT) ",
      "Surgery-II (Dentistry) ",
      "Surgery-II (Ophthalmology) ",
      "Health Management ",
      "Epidemiology ",
      "Comprechensive Clinical Practice (4 Months) ",
      "Comprechensive Community Field Practice (2 Months) ",
    ],
  },
];

const careerProspects = [
  "Health Assistants(HA)",
  "Community Health Workers",
  "Emergency Medical Technicians (EMTs)",
  "Healthcare Assistent Administrators",
];

const keyFeatures = [
  "Hands-on clinical training in affiliated hospitals and healthcare centers.",
  "Focus on both urban and rural healthcare delivery.",
  "Opportunities for research and community health projects.",
  "Emphasis on holistic patient care and medical ethics.",
];

const facilities = [
  "Modern laboratories and simulation centers.",
  "Access to a well-stocked library with medical literature.",
  "Experienced and dedicated faculty members.",
  "Internship and job placement support.",
];

const whyChooseHVTC = [
  "Experienced Faculty in General Medicine",
  "Advanced Medical Laboratories",
  "Comprehensive Medical Curriculum",
  "Strong Hospital Partnerships",
  "Extensive Clinical Training",
  "Modern Healthcare Facilities",
  "Focus on Practical Skills Development",
  "Supportive Medical Learning Environment",
];
